import LOGO from "../../assets/images/logo.png";
import EXAMPLE from "../../assets/images/example.png";
import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  readStorageJSON,
  profile,
  alert,
  GET,
  POST,
  loading,
  Modal,
} from "../../components/CustomComponent.js";
import { getAccessSides } from "../../components/access-side.js";
import { stripJuristic } from "../../components/text-sanitize.js";
export default class Console extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      active_tab: "project",
      filter_search: "",
      sales_search: "",

      data: [],
      data_project: null,
      user_profile: null,

      // มุมมองของทั้งสองแท็บ (การ์ด / รายการ) — จำค่าไว้ให้ผู้ใช้ไม่ต้องเลือกใหม่ทุกครั้ง
      view: localStorage.getItem("cds-console-view") === "list" ? "list" : "card",
    };
  }
  componentDidMount() {
    loading(false);
    if (!localStorage.getItem("cds-acc-tk")) {
      localStorage.clear();
      window.location.href = "/";
    }
    this.ApplySides();
    this.Get(1);
    this.GetProfile();
  }

  // ฝั่งที่ผู้ใช้เห็นได้ ({legal, sale}) — ดูจากคีย์สิทธิ์ใน role (ดู access-side.js)
  getSides = () => getAccessSides(this.state.user_profile || profile);

  // เลือกแท็บเริ่มต้นให้ตรงกับฝั่งที่เห็นได้ — ไม่มีสิทธิ์ฝั่งไหนก็ไม่เปิดฝั่งนั้น
  ApplySides = (prof) => {
    const sides = getAccessSides(prof || this.state.user_profile || profile);
    const wantSales = new URLSearchParams(window.location.search).get("tab") === "sales";
    let tab = wantSales ? "sales" : "project";
    if (tab === "sales" && !sides.sale) tab = "project";
    if (tab === "project" && !sides.legal && sides.sale) tab = "sales";
    this.setState({ active_tab: tab });
  };

  // สิทธิ์ใน localStorage อาจเก่า (ตั้งตอน login) — ดึงล่าสุดมาใช้แล้วเก็บกลับ
  // merge ทับของเดิม เพราะ /user/profile ไม่ได้คืนทุกฟิลด์ (เช่น user_type)
  GetProfile = async () => {
    const result = await GET("api/admin/user/profile", null, false);
    if (result?.status) {
      const cached = readStorageJSON("cds-profile");
      const merged = { ...(cached || {}), ...result.data, password: "" };
      localStorage.setItem("cds-profile", JSON.stringify(merged));
      this.setState({ user_profile: merged });
      this.ApplySides(merged);
    }
  };
  Get = async (page) => {
    loading(true);
    let result = await GET("api/admin/console/list", null);
    if (result?.status) {
      this.setState({
        data: result.data,
      });
    }
    loading(false);
  };
  GetProjectID = async (item) => {
     loading(true);
     let result = await GET("api/public/setting", { project_id: item.project_id });
     if (result?.status) {
      localStorage.setItem("cds-setting", JSON.stringify(result.data));
      localStorage.setItem("cds-project", JSON.stringify(item));
      window.location.href = "/dashboard";
    }
    loading(false);
  };
  OpenSalesProject = (item) => {
    localStorage.setItem("cds-sales-project", JSON.stringify(item));
    localStorage.setItem("cds-project", JSON.stringify(item));
    // เข้าฝั่งงานขายให้เริ่มที่แดชบอร์ด — เห็นภาพรวมโครงการก่อนลงไปรายห้อง
    window.location.href = "/sale-dashboard";
  };
  CreateUpdate = async () => {
    const { data_project } = this.state;
    loading(true);
    let body = data_project;
    let result = await POST("api/admin/upload-data", body);
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  handleFile = (file) => {
    loading(true);
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        let text = fileContent
          .replaceAll("%5F%", "_")
          .replaceAll("%5D%", "]")
          .replaceAll("%5B%", "[")
          .replaceAll("%3A%", ":")
          .replaceAll("%7D%", "}")
          .replaceAll("%7B%", "{")
          .replaceAll("%22%", '"')
          .replaceAll("%2C%", ",");
        let data = JSON.parse(text) || {};
        this.setState({
          data_project: {
            ...data,
            data_customer: [],
            data_receipt: [],
            data_water: [],
          },
          modal_create: true,
        });
        loading(false);
      };
      reader.onerror = (error) => {
        loading(false);
        console.error("Error reading file:", error);
      };
      reader.readAsText(file);
    } else {
      loading(false);
      console.log("No file selected");
    }
  };

  getSaleSummary = (item = {}) => {
    const available = Number(item.available_rooms) || 0;
    const booked = Number(item.reserved_rooms) || 0;
    const sold = Number(item.sold_rooms) || 0;
    const unregistered = Number(item.not_for_sale_rooms) || 0;
    const total = available + booked + sold + unregistered;

    return {
      total,
      available,
      booked,
      sold,
      unregistered,
    };
  };

  renderHeader = () => {
    return (
      <div className="d-flex justify-content-between mb-4 flex-wrap gap-3">
        <img
          alt="example"
          src={LOGO}
          width={100}
          style={{ objectFit: "contain" }}
        />
        <div
          className="d-flex align-items-center bg-white py-1 px-1"
          style={{ borderRadius: 26 }}
        >
          <div className="bg-success-light text-success wpx-40 hpx-40 d-flex justify-content-center align-items-center rounded-circle me-3">
            {profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
          </div>
          <div className="me-3">
            <div className="fw-bold">
              {/* ★ เดิมโชว์ข้อความตัวอย่าง "fisrtname lastname / example@email.com" ตอนยังไม่มีข้อมูล → แสดงว่างแทน */}
              {profile?.full_name || ""}
            </div>
            <small className="me-2">
              {profile?.email || ""}
            </small>
          </div>
          <Dropdown>
            <Dropdown.Toggle variant="gray" id="dropdown-basic" size="sm">
              <span className="icon pointer text-24 me-2">{"\uf107"}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
              <Dropdown.Item
                className="rounded-3 d-flex align-items-center px-2"
                onClick={() => {}}
              >
                <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                  {"\uf007"}
                </div>{" "}
                โปรไฟล์
              </Dropdown.Item>
              <Dropdown.Item
                className="rounded-3 d-flex align-items-center px-2"
                onClick={async () => {
                  if (
                    await alert(
                      "",
                      "warning",
                      "ออกจากระบบ",
                      "ยืนยันการออกจากระบบหรือไม่?",
                      "ออกจากระบบ",
                      "ยกเลิก"
                    )
                  ) {
                    localStorage.clear();
                    window.location.href = "/";
                  }
                }}
              >
                <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                  {"\uf2f5"}
                </div>{" "}
                ออกจากระบบ
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  };

  setView = (view) => {
    localStorage.setItem("cds-console-view", view);
    this.setState({ view });
  };

  // ปุ่มสลับมุมมอง — ใช้ร่วมกันทั้งแท็บหน้าหลักและแท็บการขาย
  renderViewToggle = () => (
    <div className="console-view-toggle" data-testid="console-view-toggle">
      <button
        type="button"
        className={`console-view-btn ${this.state.view === "card" ? "active" : ""}`}
        title="มุมมองการ์ด"
        onClick={() => this.setView("card")}
      >
        <span className="icon">{"\uf00a"}</span>
      </button>
      <button
        type="button"
        className={`console-view-btn ${this.state.view === "list" ? "active" : ""}`}
        title="มุมมองรายการ"
        onClick={() => this.setView("list")}
      >
        <span className="icon">{"\uf03a"}</span>
      </button>
    </div>
  );

  // ★ การ์ดโครงการ 1 ใบ — ใช้โครงเดียวกันทั้ง 2 แท็บ ต่างกันแค่ "ป้าย" กับ "ปุ่ม"
  //   (เดิมแท็บหน้าหลักกับแท็บการขายเขียนคนละชุด หน้าตาเลยไม่เหมือนกัน)
  projectTile = (item, index, opts) => (
    <div
      key={`tile-${item.project_id || index}`}
      className="col-12 col-sm-6 col-md-4 col-xl-3 mb-3 pointer console-hover"
      onClick={() => opts.onOpen(item)}
    >
      <div className="card rounded-4 border-0 shadow p-0 overflow-hidden position-relative select-project h-100">
        {/* ★ โครงการที่ไม่มีรูปเดิมได้กรอบเทาว่างเปล่า — ใส่ไอคอนแทนให้รู้ว่า "ไม่มีรูป" ไม่ใช่โหลดไม่ขึ้น */}
        <div className="console-tile-media d-none d-sm-flex">
          {item.picture ? (
            <img
              alt={item.project_name || "project"}
              src={item.picture}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = EXAMPLE;
              }}
            />
          ) : (
            <span className="icon console-tile-media__ghost">{"\uf1ad"}</span>
          )}
        </div>
        <div className="card-body p-3 d-flex flex-column">
          {/* ชื่อโครงการยาวไม่เท่ากัน ตัด 2 บรรทัดให้การ์ดสูงเท่ากันทั้งแถว */}
          <h5 className="console-tile-name mb-1" title={stripJuristic(item.project_name) || "-"}>
            {stripJuristic(item.project_name) || "-"}
          </h5>
          <small className="text-secondary">{opts.meta}</small>

          {/* ป้ายสถานะจัดเป็นตาราง 2x2 — เดิมไหลตามความกว้าง เลยตกบรรทัดไม่เท่ากันทุกใบ */}
          {!!opts.pills?.length && (
            <div className="console-tile-pills mt-3">
              {opts.pills.map((pill) => (
                <div className={`console-sales-pill ${pill.tone}`} key={pill.label}>
                  <span>{pill.label}</span>
                  <strong>{pill.value}</strong>
                </div>
              ))}
            </div>
          )}

          <button
            type="button"
            className="console-open-btn w-100 mt-3"
            onClick={(e) => {
              e.stopPropagation();
              opts.onOpen(item);
            }}
          >
            <span>{opts.actionLabel}</span>
            <span className="icon">{"\uf061"}</span>
          </button>
        </div>

        {!!opts.ribbon && (
          <div
            className={`wpx-150 text-center position-absolute py-1 shadow ${opts.ribbon.tone}`}
            style={{ right: -35, top: 15, transform: "rotate(36deg)" }}
          >
            {opts.ribbon.label}
          </div>
        )}
      </div>
    </div>
  );

  // ★ แถวโครงการ 1 แถว (มุมมองรายการ) — โครงเดียวกันทั้ง 2 แท็บเช่นกัน
  projectRow = (item, index, opts) => (
    <div key={`row-${item.project_id || index}`} className="console-sales-row pointer" onClick={() => opts.onOpen(item)}>
      <div className="console-sales-row-main">
        <img
          alt={item.project_name || "project"}
          src={item.picture || EXAMPLE}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = EXAMPLE;
          }}
          className="console-sales-thumb"
        />
        <div className="console-sales-row-info">
          <h5 className="mb-1 console-project-name-ellipsis" title={stripJuristic(item.project_name) || "-"}>
            {stripJuristic(item.project_name) || "-"}
          </h5>
          <div className="console-sales-row-meta">
            <span>{opts.meta}</span>
          </div>
        </div>
      </div>

      <div className="console-sales-badges">
        {(opts.pills || []).map((pill) => (
          <div className={`console-sales-pill ${pill.tone}`} key={pill.label}>
            <span>{pill.label}</span>
            <strong>{pill.value}</strong>
          </div>
        ))}
        {!opts.pills?.length && !!opts.ribbon && (
          <div className={`console-sales-pill ${opts.ribbon.tone === "bg-success-light text-success" ? "available" : "unregistered"}`}>
            <span>{opts.ribbon.label}</span>
          </div>
        )}
      </div>

      <div className="console-sales-actions">
        <button
          className="console-open-btn"
          onClick={(e) => {
            e.stopPropagation();
            opts.onOpen(item);
          }}
        >
          <span>{opts.actionLabel}</span>
          <span className="icon">{"\uf061"}</span>
        </button>
      </div>
    </div>
  );

  // แท็บ "หน้าหลัก" — เข้าไปจัดการข้อมูลของโครงการ
  renderProjectTab = (filteredProjects) => {
    const { view } = this.state;
    const isAdmin = ["super_user", "admin"].includes(profile?.user_type);

    const options = (item) => ({
      meta: `หมายเลขผู้เสียภาษี : ${item.tax_number || "-"}`,
      actionLabel: "เข้าจัดการโครงการ",
      onOpen: this.GetProjectID,
      ribbon: item.is_update
        ? { label: "อัพเดทแล้ว", tone: "bg-success-light text-success" }
        : { label: "รออัพเดท", tone: "bg-danger-light text-danger" },
    });

    // การ์ดพิเศษ 2 ใบ (เมนูผู้ดูแล / อัปโหลดข้อมูล) มีเฉพาะแท็บนี้และเฉพาะ admin
    const adminTile = (
      <div
        key="admin-tile"
        className="col-12 col-sm-6 col-md-4 col-xl-3 mb-3 pointer console-hover"
        onClick={() => {
          localStorage.removeItem("cds-project");
          window.location.href = "/user";
        }}
      >
        <div className="card rounded-4 border-0 shadow p-0 overflow-hidden position-relative select-project h-100">
          <div className="card-header p-0 d-none d-sm-flex bg-success-light hpx-170 align-items-center justify-content-center border-0">
            <h1 className="text-success text-48">ADMIN</h1>
          </div>
          <div className="card-body p-3">
            <h5>เมนูสำหรับผู้ดูแลระบบ</h5>
            <small className="text-secondary">เข้าสู่หน้าจัดการข้อมูล</small>
          </div>
        </div>
      </div>
    );

    const uploadTile = (
      <div
        key="upload-tile"
        className="col-12 col-sm-6 col-md-4 col-xl-3 mb-3 pointer console-hover"
        onClick={() => document.getElementById("file").click()}
        onDragOver={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          this.handleFile(e.dataTransfer.files?.[0]);
        }}
      >
        <div
          className="card rounded-4 border-2 border-dash shadow p-0 overflow-hidden position-relative select-project"
          style={{ height: 245 }}
        >
          <div className="text-center text-secondary py-5">
            <span className="icon text-48">{"\uf15b"}</span>
            <h5 className="fw-bold">อัพโหลดข้อมูลโครงการ</h5>
            <label className="px-3">รองรับรูปแบบไฟล์ TXT และขนาดไฟล์ไม่เกิน 50 เมกะไบท์</label>
          </div>
        </div>
      </div>
    );

    // แถบสรุป — ชุดเดียวกับแท็บการขาย ให้สองแท็บอ่านเป็นหน้าเดียวกัน
    const updated = filteredProjects.filter((item) => item.is_update).length;
    const pending = filteredProjects.length - updated;
    const roomTotal = filteredProjects.reduce((sum, item) => sum + this.getSaleSummary(item).total, 0);

    const toolbar = (
      <div className="console-sales-toolbar card border-0 shadow-sm rounded-4 mb-3">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="console-sales-toolbar-copy">
              <h4 className="fw-bold mb-1">รายการโครงการทั้งหมด</h4>
              <small className="text-secondary">เลือกโครงการเพื่อเข้าไปจัดการข้อมูล และดูสถานะการอัพเดทข้อมูล</small>
            </div>
            <div className="console-sales-mini-stats">
              <div className="console-stat-card compact border">
                <span>โครงการ</span>
                <strong>{filteredProjects.length}</strong>
              </div>
              <div className="console-stat-card compact available">
                <span>อัพเดทแล้ว</span>
                <strong>{updated}</strong>
              </div>
              <div className="console-stat-card compact unregistered">
                <span>รออัพเดท</span>
                <strong>{pending}</strong>
              </div>
              <div className="console-stat-card compact booked">
                <span>ห้องทั้งหมด</span>
                <strong>{roomTotal}</strong>
              </div>
              {/* ★ ปุ่มประจำแท็บนี้คืออัพโหลดข้อมูล (คู่กับปุ่ม Landing Page ของแท็บการขาย) */}
              {isAdmin && (
                <button
                  type="button"
                  className="console-open-btn console-landing-btn"
                  onClick={() => document.getElementById("file").click()}
                >
                  <span>อัพโหลดข้อมูล</span>
                  <span className="icon">{"\uf15b"}</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );

    if (view === "list") {
      return (
        <>
        {toolbar}
        <div className="card border-0 shadow rounded-4 p-3">

          {/* ★ งานของผู้ดูแลระบบไม่ใช่ "โครงการ" จึงแยกเป็นแถวปุ่มด้านล่าง ไม่ปนกับรายการ */}
          {isAdmin && (
            <div className="d-flex flex-wrap gap-2 mb-3">
              <button
                type="button"
                className="console-open-btn"
                onClick={() => {
                  localStorage.removeItem("cds-project");
                  window.location.href = "/user";
                }}
              >
                <span>เมนูสำหรับผู้ดูแลระบบ</span>
                <span className="icon">{"\uf061"}</span>
              </button>
              <button type="button" className="console-open-btn" onClick={() => document.getElementById("file").click()}>
                <span>อัพโหลดข้อมูลโครงการ</span>
                <span className="icon">{"\uf15b"}</span>
              </button>
            </div>
          )}
          <div className="console-sales-list">
            {filteredProjects?.map((item, index) => this.projectRow(item, index, options(item)))}
          </div>
        </div>
        </>
      );
    }

    return (
      <>
      {toolbar}
      <div className="row">
        {isAdmin && adminTile}
        {filteredProjects?.map((item, index) => this.projectTile(item, index, options(item)))}
        {isAdmin && uploadTile}
      </div>
      </>
    );
  };

  // แท็บ "การขาย" — เข้าไปจัดการห้องขาย/ให้เช่าของโครงการ
  renderSalesTab = (filteredProjects) => {
    const { view } = this.state;
    const totals = filteredProjects.reduce(
      (sum, item) => {
        const summary = this.getSaleSummary(item);
        sum.available += summary.available;
        sum.booked += summary.booked;
        sum.sold += summary.sold;
        sum.total += summary.total;
        sum.unregistered += summary.unregistered;
        return sum;
      },
      { available: 0, booked: 0, sold: 0, total: 0, unregistered: 0 }
    );

    const options = (item) => {
      const summary = this.getSaleSummary(item);
      return {
        meta: `ทั้งหมด ${summary.total} ห้อง`,
        actionLabel: "เปิดจัดการห้องขาย",
        onOpen: this.OpenSalesProject,
        pills: [
          { label: "ว่าง", value: summary.available, tone: "available" },
          { label: "จอง", value: summary.booked, tone: "booked" },
          { label: "ขายแล้ว", value: summary.sold, tone: "sold" },
          { label: "ไม่ลงขาย", value: summary.unregistered, tone: "unregistered" },
        ],
      };
    };

    return (
      <div>
        <div className="console-sales-toolbar card border-0 shadow-sm rounded-4 mb-3">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div className="console-sales-toolbar-copy">
                <h4 className="fw-bold mb-1">รายการโครงการสำหรับการขาย</h4>
                <small className="text-secondary">ดูจำนวนห้องรวมและสถานะ ว่าง จอง ขายแล้ว และไม่ลงขาย</small>
              </div>
              <div className="console-sales-mini-stats">
                <div className="console-stat-card compact border">
                  <span>โครงการ</span>
                  <strong>{filteredProjects.length}</strong>
                </div>
                <div className="console-stat-card compact available">
                  <span>ห้องว่างรวม</span>
                  <strong>{totals.available}</strong>
                </div>
                <div className="console-stat-card compact booked">
                  <span>ห้องจองรวม</span>
                  <strong>{totals.booked}</strong>
                </div>
                <div className="console-stat-card compact sold">
                  <span>ห้องขายแล้ว</span>
                  <strong>{totals.sold}</strong>
                </div>
                <div className="console-stat-card compact unregistered">
                  <span>ห้องที่ไม่ลงขาย</span>
                  <strong>{totals.unregistered}</strong>
                </div>
                <button
                  type="button"
                  className="console-open-btn console-landing-btn"
                  onClick={() => {
                    const saleSiteUrl = process.env.REACT_APP_SALE_SITE_URL;
                    if (!saleSiteUrl) {
                      alert(null, "warning", "\u0e22\u0e31\u0e07\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32 Landing Page", "\u0e23\u0e30\u0e1a\u0e1a\u0e22\u0e31\u0e07\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32 URL \u0e02\u0e2d\u0e07\u0e2b\u0e19\u0e49\u0e32 Sale Page \u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e1c\u0e39\u0e49\u0e14\u0e39\u0e41\u0e25\u0e23\u0e30\u0e1a\u0e1a");
                      return;
                    }
                    window.open(saleSiteUrl + "/overview", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span>Landing Page</span>
                  <span className="icon">{"\uf08e"}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {view === "list" ? (
          <div className="card border-0 shadow rounded-4 p-3">
            <div className="console-sales-list">
              {filteredProjects?.map((item, index) => this.projectRow(item, index, options(item)))}
            </div>
          </div>
        ) : (
          <div className="row">
            {filteredProjects?.map((item, index) => this.projectTile(item, index, options(item)))}
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      modal_create,
      active_tab,
      filter_search,
      sales_search,
      data,
      data_project,
    } = this.state;
    const sides = this.getSides();
    const keyword =
      active_tab === "project" ? filter_search : sales_search;
    const searchPlaceholder =
      active_tab === "project"
        ? "ค้นหา..."
        : "ค้นหาชื่อโครงการ...";
    const filteredProjects = data?.filter((item) => {
      if (!keyword) return true;
      return [item.project_name, item.tax_number]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(keyword.toLowerCase());
    });

    return (
      <div className="w-100 min-vh-100 background">
        <input
          hidden
          id="file"
          type="file"
          onChange={async (e) => {
            const file = e.target.files[0];
            this.handleFile(file);
          }}
        />
        <div className="container py-3">
          {this.renderHeader()}

          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
            <input
              type="text"
              className="form-control wpx-250"
              placeholder={searchPlaceholder}
              onChange={(e) => {
                this.setState(
                  active_tab === "project"
                    ? { filter_search: e.target.value }
                    : { sales_search: e.target.value }
                );
              }}
              value={keyword}
            />

            <div className="d-flex align-items-center gap-2 flex-wrap">
            {this.renderViewToggle()}
            {sides.legal && sides.sale && (
            <div className="console-tab-wrap">
              <button
                className={`console-tab-btn ${
                  active_tab === "project" ? "active" : ""
                }`}
                onClick={() => {
                  this.setState({ active_tab: "project" });
                }}
              >
                หน้าหลัก
              </button>
              <button
                className={`console-tab-btn ${
                  active_tab === "sales" ? "active" : ""
                }`}
                onClick={() => {
                  this.setState({ active_tab: "sales" });
                }}
              >
                การขาย
              </button>
            </div>
            )}
            </div>
          </div>

          {active_tab === "project"
            ? (sides.legal ? this.renderProjectTab(filteredProjects) : null)
            : (sides.sale ? this.renderSalesTab(filteredProjects) : null)}
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">ข้อมูลโครงการ</h5>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mx-auto mb-3">
                <img
                  alt="logo"
                  src={data_project?.data_project?.picture}
                  className="hpx-120 wpx-120 rounded-circle bg-light"
                />
              </div>
              <div className="col-12 col-sm-6 d-flex mb-3">
                <div className="fw-bold wpx-100">ชื่อโครงการ</div>
                <span>{stripJuristic(data_project?.data_project?.project_name)}</span>
              </div>
              <div className="col-12 col-sm-6 d-flex mb-3">
                <div className="fw-bold wpx-100">เบอร์โทรศัพท์</div>
                <span>{data_project?.data_project?.phone_number}</span>
              </div>
              <div className="col-12 col-sm-6 d-flex mb-3">
                <div className="fw-bold wpx-100">เลขที่ผู้เสียภาษี</div>
                <span>{data_project?.data_project?.tax_number}</span>
              </div>
              <div className="col-12 d-flex mb-3">
                <div className="fw-bold wpx-100">ที่อยู่</div>
                <span>
                  {data_project?.data_project?.address_detail} ตำบล{" "}
                  {data_project?.data_project?.address_obj?.SUB_DISTRICT} อำเภอ{" "}
                  {data_project?.data_project?.address_obj?.DISTRICT} จังหวัด{" "}
                  {data_project?.data_project?.address_obj?.PROVINCE}{" "}
                  {data_project?.data_project?.address_obj?.ZIPCODE}
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                เพิ่มโครงการ
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
